import { useAtomValue, useSetAtom } from "jotai";
import {
  checkRemittanceForApprovalAtom,
  isRemittanceApprovalCheckingAtom,
  isRemittanceApprovalSendingAtom,
  sendRemittanceForApprovalAtom,
} from "@/store/deduction/remittance";

export function useRemittanceSendForApproval() {
  const isRemittanceApprovalSending = useAtomValue(isRemittanceApprovalSendingAtom);
  const isRemittanceApprovalChecking = useAtomValue(isRemittanceApprovalCheckingAtom);
  const checkRemittanceForApproval = useSetAtom(checkRemittanceForApprovalAtom);
  const sendRemittanceForApproval = useSetAtom(sendRemittanceForApprovalAtom);

  return {
    isRemittanceApprovalSending,
    isRemittanceApprovalChecking,
    checkRemittanceForApproval,
    sendRemittanceForApproval,
  };
}
